import { css } from 'styled-components'

// The rgba line is the fallback for browsers without color-mix support.
export const frostedChipSurface = css`
  background-color: rgba(255, 255, 255, 0.72);
  background-color: color-mix(
    in srgb,
    ${({ theme }) => theme['-ds-bg-container-default']} 72%,
    transparent
  );
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
`
